export const PUSH_HISTORY = '@nav/PUSH_HISTORY';

export const GO_BACK_IF_PREVIOUS_STATE = 'GO_BACK_IF_PREVIOUS_STATE';
